import React, { useEffect, useState } from 'react';
import withQuillLayout from 'src/_common/hoc/QuillLayout';
import StudentResources from 'src/mics/components/studentResources/StudentResources';

export default withQuillLayout({
  children: StudentResources,
});
